import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import ListView from "../common/ListView";
import {searchReturnReasons, updateReturnReasonVisibility} from "./actions";
import {Link} from "react-router-dom";
import {Icon, notification} from "antd";

class ReturnReasonsPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    /* state */
    search: PropTypes.object.isRequired,
    /* actions */
    searchReturnReasons: PropTypes.func.isRequired,
    updateReturnReasonVisibility: PropTypes.func.isRequired,
  };

  onVisibilityClick = async(values) => {
    try {
      await this.props.updateReturnReasonVisibility(values);
      this.listView.refresh();
    } catch (err) {
      notification.error({
        message: 'Failed changing visibility',
        description: err.message,
      });
    }
  };

  render() {
    const {
      history, searchReturnReasons,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true
      },
      {
        title: 'Visibility',
        key: 'visibility',
        render: (_, {returnReasonId, visibleOnTill}) =>
          <Icon
            type="shopping-cart"
            style={{color: visibleOnTill ? 'green' : 'red', cursor: 'pointer'}}
            onClick={() => this.onVisibilityClick({returnReasonId, visibleOnTill: !visibleOnTill})}
          />
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, {returnReasonId}) => <Link to={`/return-reason/update/${encodeURIComponent(returnReasonId)}`}>Edit</Link>,
      },
    ];
    return (
      <ListView
        ref={ref => this.listView = ref}
        title="Return Reasons"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchReturnReasons}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        onAdd={() => history.push('/return-reason/add')}
        rowKey="returnReasonId"
      />
    );
  }
}

const mapStateToProps = state => ({
  search: state.returnReason.search,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchReturnReasons,
  updateReturnReasonVisibility,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(ReturnReasonsPage);



// WEBPACK FOOTER //
// ./src/ReturnReason/ReturnReasonsPage.js